export function priceCents(value) {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 && number <= 1 ? Math.round(number * 100) : null;
}

export const firstText = (...values) =>
  values.find((value) => typeof value === 'string' && value.trim())?.trim() || '';
export function safeColor(value, fallback = '#2557a7') {
  return /^#[\da-f]{6}$/i.test(value || '') ? value : fallback;
}

export function initials(name) {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0])
    .join('');
}
